export enum WorkflowCreatorPermissionType {
  Edit = 'EDIT',
  Review = 'REVIEW',
  Sign = 'SIGN',
  Finalize = 'FINALIZE',
  Ticket = 'TICKET',
}
